<template>
  <div class="enroll-student-attachment-select">
    <div class="attachment-select-container">
      <el-row>
        <el-col class="notice">
          <el-row>
            <el-col :span="2"> 温馨提示:</el-col>
            <el-col :span="20"> 按文件类型下载：以勾选类型为zip包单位，每个类型包有所有人员的附件</el-col>
          </el-row>
          <el-row>
            <el-col :span="2">&nbsp;</el-col>
            <el-col :span="20"> 按个人形式下载：以人员为zip包单位，每个包里含该人员上传的所有附件</el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row style="height: 60px">&nbsp;</el-row>
      <el-row>
        <el-col :span="4">选择附件：</el-col>
        <el-col :span="20">
          <div class="attachment-checkbox">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选
            </el-checkbox>
            <div style="margin: 15px 0;"></div>
            <el-checkbox-group v-model="checkedOptions" @change="handleCheckedCitiesChange">
              <el-checkbox v-for="option in options" :label="option.code" :key="option.code"
                           style="width: 25%;line-height: 30px">
                {{ option.name }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </el-col>
      </el-row>
      <el-row style="height: 50px"></el-row>
      <el-row align="middle" type="flex" justify="center">
        <el-button class="download-button" @click="downloadStudentAttachments('type')" :loading="loading">
          按文件类型下载
        </el-button>
        <el-button class="download-button" @click="downloadStudentAttachments('student')" :loading="loading">
          按学生形式下载
        </el-button>
      </el-row>
      <el-row style="height: 20px"></el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EnrollStudentAttachmentSelect',
  props: {
    preHandleParams: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      isIndeterminate: false,
      checkedOptions: [],
      options: [
        {code: 'studentDetailPdf', name: '学生详情PDF    '},
        {code: 'studentRegisterFormPdf', name: '报名登记表   '},
        {code: 'idCardFront', name: '身份证正面     '},
        {code: 'idCardBack', name: '身份证反面     '},
        {code: 'userPhoto', name: '个人照片       '},
        {code: 'degreePhoto', name: '学历证书         '},
        {code: 'recommendLetter', name: '推荐信      '}
      ],
      checkAll: false,
      loading: false
    }
  },
  methods: {
    handleCheckAllChange (val) {
      this.checkedOptions = []
      if (val) {
        this.options.forEach(item => {
          this.checkedOptions.push(item.code)
        })
      }
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange (value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.options.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.options.length
    },
    downloadStudentAttachments (type) {
      if (this.checkedOptions.length === 0) {
        this.$message({message: '请选择要下载的内容', type: 'warning'})
        return
      }
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/student/downloadStudentAttachment',
        method: 'post',
        data: this.$qs.stringify(this.$extend({
          checkedOptions: this.checkedOptions,
          groupType: type
        }, this.preHandleParams()), {
          arrayFormat: 'repeat'
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              window.location.href = response.data['link']
              break
            }
            default: {
              this.$message({
                message: response.data['message'],
                type: 'warning'
              })
              break
            }
          }
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss">
  @import '../../../../../../styles/color.scss';

  .enroll-student-attachment-select {
    .attachment-select-container {
      padding: 20px;
      background-color: #fff;

      .notice {
        font-size: 12px;
        color: $set-warning-color;
      }

      .attachment-checkbox {
        border-radius: 3px;
        padding-left: 20px;
        display: inline-block;
        .el-checkbox__label {
          white-space: normal;
        }
      }
    }
  }
</style>
